// REWARDS PAGE JS + Gentle Loader Overlay
(function () {

  // -----------------------------
// Loader overlay (Liquid-rendered)
// -----------------------------
const LOADER_ID = "nani-js-loader";
const LOADER_ACTIVE = "is-active";
const LOADER_HIDING = "is-hiding";
const LOADER_FAILSAFE_MS = 9000;

function getLoaderEl() {
  return document.getElementById(LOADER_ID);
}

function showLoader() {
  const el = getLoaderEl();
  if (!el) return;

  el.classList.remove(LOADER_HIDING);
  el.classList.add(LOADER_ACTIVE);

  if (!el.__naniFailsafe) {
    el.__naniFailsafe = setTimeout(hideLoader, LOADER_FAILSAFE_MS);
  }
}

function hideLoader() {
  const el = getLoaderEl();
  if (!el) return;

  el.classList.add(LOADER_HIDING);
  el.classList.remove(LOADER_ACTIVE);

  if (el.__naniFailsafe) {
    clearTimeout(el.__naniFailsafe);
    el.__naniFailsafe = null;
  }

  // If Liquid keeps it in DOM, don't remove it—just leave hidden.
  // If you DO want removal, uncomment next line:
  // setTimeout(() => el.remove(), 260);
}

// -----------------------------
// Loader hide strategy (keep)
// -----------------------------
function hideLoaderAfterInitialPasses() {
  const HIDE_AFTER_MS = 1600;

  setTimeout(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        hideLoader();
      });
    });
  }, HIDE_AFTER_MS);
}

// If Liquid renders it visible by default, keep this.
// If Liquid renders it hidden by default, you can remove showLoader().
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    showLoader();
    hideLoaderAfterInitialPasses();
  });
} else {
  showLoader();
  hideLoaderAfterInitialPasses();
}



// Replace "Points" -> "Miles" anywhere in the Okendo loyalty widget
(function () {
  const ROOT_SELECTOR = '[data-oke-loyalty-embedded-widget], #oke-loyalty-earn, #oke-loyalty-redeem';
  const FROM = /\bPoints\b/g; // whole word, case-sensitive
  const TO = "Miles";

  // Attributes where "Points" often appears
  const ATTRS = ["aria-label", "title", "placeholder", "value"];

  function swapText(str) {
    if (!str || typeof str !== "string") return str;
    return str.replace(FROM, TO);
  }

  function replaceInTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        // skip empty + script/style + hidden template-ish nodes
        if (!node.nodeValue || !node.nodeValue.match(FROM)) return NodeFilter.FILTER_REJECT;
        const p = node.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        const tag = p.tagName;
        if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT") return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    let n;
    while ((n = walker.nextNode())) {
      n.nodeValue = swapText(n.nodeValue);
    }
  }

  function replaceInAttributes(root) {
    const all = root.querySelectorAll("*");
    all.forEach((el) => {
      ATTRS.forEach((attr) => {
        if (!el.hasAttribute(attr)) return;
        const v = el.getAttribute(attr);
        const nv = swapText(v);
        if (nv !== v) el.setAttribute(attr, nv);
      });
    });
  }

  function apply() {
    const root =
      document.querySelector(ROOT_SELECTOR) ||
      document.getElementById("shopify-block-AMWdRK2tqR3RTUGNRW__okendo_loyalty_embedded_widget_wriTLA");

    if (!root) return false;

    replaceInTextNodes(root);
    replaceInAttributes(root);
    return true;
  }

  // Run a few times during hydration
  function startPolling() {
    let tries = 0;
    const maxTries = 40; // ~12s
    const t = setInterval(() => {
      tries++;
      apply();
      if (tries >= maxTries) clearInterval(t);
    }, 300);
  }

  // Then keep it updated as Okendo re-renders
  function startObserver() {
    const root =
      document.querySelector(ROOT_SELECTOR) ||
      document.getElementById("shopify-block-AMWdRK2tqR3RTUGNRW__okendo_loyalty_embedded_widget_wriTLA");

    if (!root) return;

    const obs = new MutationObserver(() => apply());
    obs.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      startPolling();
      setTimeout(startObserver, 800);
    });
  } else {
    startPolling();
    setTimeout(startObserver, 800);
  }
})();


  // 2) JOIN NOW button wiring
  (function () {
    const BUTTON_TEXT = "JOIN NOW";
    const CARD_SELECTOR = ".c-customisableActionCard";
    const PROCESSED_ATTR = "data-nani-join-button";

    const FIXED_RETURN_PATH = "/pages/nani-nomads-adventure-club";
    // NOTE: you previously commented out LOGIN_URL; keep it commented if you’re handling elsewhere.
    const LOGIN_URL = `/customer_authentication/login?return_to=${encodeURIComponent(FIXED_RETURN_PATH)}`;

    let observer = null;
    let scheduled = false;

    function isLoggedInOkendo() {
      return !!document.querySelector(
        ".c-loggedInMemberCardRow, .c-loggedInMemberCardRow--customisable, .c-customisableProfile-balance, #oke-loyalty-profile"
      );
    }

    function wireJoinNowButton(btn) {
      if (!btn || btn.__naniJoinWired) return;
      btn.__naniJoinWired = true;

      if (btn.textContent.trim() !== BUTTON_TEXT) btn.textContent = BUTTON_TEXT;
      btn.setAttribute("aria-label", BUTTON_TEXT);

      btn.addEventListener("click", (e) => {
        // If you want the redirect active, uncomment:
        e.preventDefault();
        // e.stopPropagation();
        window.location.href = LOGIN_URL;
      });
    }

    function applyOnce() {
      if (isLoggedInOkendo()) return;

      const cards = document.querySelectorAll(CARD_SELECTOR);
      if (!cards.length) return;

      if (observer) observer.disconnect();

      try {
        cards.forEach((card) => {
          card
            .querySelectorAll("button.c-button, button[aria-label]")
            .forEach((btn) => {
              const label = (btn.getAttribute("aria-label") || btn.textContent || "").trim();
              if (label === BUTTON_TEXT) wireJoinNowButton(btn);
            });

          if (card.hasAttribute(PROCESSED_ATTR)) {
            const btn = card.querySelector("button.c-button");
            if (btn && btn.textContent.trim() !== BUTTON_TEXT) {
              btn.textContent = BUTTON_TEXT;
              btn.setAttribute("aria-label", BUTTON_TEXT);
            }

            const joinBtn = Array.from(card.querySelectorAll("button")).find(
              (b) => ((b.getAttribute("aria-label") || b.textContent || "").trim() === BUTTON_TEXT)
            );
            if (joinBtn) wireJoinNowButton(joinBtn);

            return;
          }

          card.setAttribute(PROCESSED_ATTR, "1");

          const existingBtn = card.querySelector("button.c-button");
          if (existingBtn) {
            existingBtn.textContent = BUTTON_TEXT;
            existingBtn.setAttribute("aria-label", BUTTON_TEXT);
            wireJoinNowButton(existingBtn);
            return;
          }

          let actionArea = card.querySelector(".c-customisableActionCard-action");
          if (!actionArea) {
            actionArea = document.createElement("div");
            actionArea.className =
              "c-customisableActionCard-action--column c-customisableActionCard-action";
            card.appendChild(actionArea);
          }

          if (actionArea.querySelector("button.c-button")) return;

          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "c-button--customisable c-button c-button--stretch";
          btn.textContent = BUTTON_TEXT;
          btn.setAttribute("aria-label", BUTTON_TEXT);

          wireJoinNowButton(btn);

          actionArea.appendChild(btn);
          card.classList.add("c-actionCard--withButton");
        });
      } finally {
        if (observer) startObserver();
      }
    }

    function runDebounced() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        applyOnce();
      });
    }

    function startObserver() {
      if (isLoggedInOkendo()) return;

      observer = observer || new MutationObserver(runDebounced);
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }

    document.addEventListener("DOMContentLoaded", () => {
      applyOnce();
      setTimeout(applyOnce, 400);
      setTimeout(applyOnce, 1200);
      startObserver();
    });
  })();

  // 3) Wrap cards media/content
  (() => {
    const ROOT_SELECTOR = "#oke-loyalty-redeem";
    const CARD_SELECTOR =
      ".c-customisableActionCard.c-customisableActionCard--withImage";
    const IMAGE_SELECTOR = ".c-customisableActionCard-image";

    const START_DELAY = 300;
    const RETRY_DELAY = 500;
    const MAX_RETRIES = 10;

    function wrapCard(card) {
      if (card.dataset.naniWrapped === "1") return;

      const img = card.querySelector(IMAGE_SELECTOR);
      if (!img) return;

      const mediaWrap = document.createElement("div");
      mediaWrap.className = "nani-okendo-card__media";

      const contentWrap = document.createElement("div");
      contentWrap.className = "nani-okendo-card__content";

      card.insertBefore(mediaWrap, img);
      mediaWrap.appendChild(img);

      card.insertBefore(contentWrap, mediaWrap.nextSibling);

      const toMove = [];
      Array.from(card.childNodes).forEach((node) => {
        if (node === mediaWrap || node === contentWrap) return;
        if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) return;
        toMove.push(node);
      });

      toMove.forEach((node) => contentWrap.appendChild(node));

      card.dataset.naniWrapped = "1";
    }

    function wrapAllCards(root) {
      const cards = root.querySelectorAll(CARD_SELECTOR);
      if (!cards.length) return false;

      cards.forEach(wrapCard);
      return true;
    }

    function observe(root) {
      const obs = new MutationObserver(() => wrapAllCards(root));
      obs.observe(root, { childList: true, subtree: true });
    }

    function tryInit(attempt = 0) {
      const root = document.querySelector(ROOT_SELECTOR);
      if (!root) {
        if (attempt < MAX_RETRIES) {
          setTimeout(() => tryInit(attempt + 1), RETRY_DELAY);
        }
        return;
      }

      const success = wrapAllCards(root);
      if (!success && attempt < MAX_RETRIES) {
        setTimeout(() => tryInit(attempt + 1), RETRY_DELAY);
        return;
      }

      observe(root);
    }

    setTimeout(() => tryInit(0), START_DELAY);
  })();

  // 4) Hide redeem section when logged out
  (() => {
    const REDEEM_SELECTOR = ".c-customisableRedeem";

    function isLoggedInOkendo() {
      return !!document.querySelector(
        ".c-loggedInMemberCardRow, .c-loggedInMemberCardRow--customisable, .c-customisableProfile-balance, #oke-loyalty-profile"
      );
    }

    const START_DELAY = 300;
    const DEBOUNCE_MS = 50;

    let scheduled = false;

    function apply() {
      const redeem = document.querySelector(REDEEM_SELECTOR);
      if (!redeem) return;

      if (!isLoggedInOkendo()) {
        redeem.style.display = "none";
      } else {
        redeem.style.display = "";
      }
    }

    function applyDebounced() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        apply();
      }, DEBOUNCE_MS);
    }

    function init() {
      apply();
      setTimeout(apply, 400);
      setTimeout(apply, 1200);

      const obs = new MutationObserver(applyDebounced);
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }

    setTimeout(init, START_DELAY);
  })();

// 5) Replace specific card buttons with survey triggers
(function () {
  const TARGETS = [
    {
      titles: ["Get Outside & Hit 10k Steps"],
      eventName: "10ksteps",
      buttonText: "Log 10k Steps",
      action: "okendo_survey",
    },
    {
      titles: ["Do a Random Act Of Kindess", "Do a Random Act Of Kindness"],
      eventName: "actofkindness",
      buttonText: "Log Kindness",
      action: "okendo_survey",
    },
    {
      // Email stays as survey (unchanged)
      titles: ["Subscribe to Emails"],
      eventName: "rewardsemail",
      buttonText: "Sign Up",
      action: "okendo_survey",
    },
    {
      // SMS signup opens Klaviyo popup
      titles: ["SMS signup"],
      buttonText: "Sign Up",
      action: "klaviyo_popup",
      klaviyoFormId: "WHGNEV",
    },
  ];

  const CARD_SELECTOR = ".c-customisableActionCard";
  const TITLE_SELECTOR = ".c-customisableActionCard-titleArea-title";
  const EXISTING_BTN_SELECTOR = ".c-customisableActionCard-action button.c-button";
  const PROCESSED_ATTR = "data-nani-custom-btn";

  function openOkendoSurveyBubbleWithRetry() {
    let tries = 0;
    const t = setInterval(() => {
      tries++;

      if (window.jQuery) {
        const $bubble = window.jQuery(".okeSurveys .c-floatingBubble");
        if ($bubble.length) {
          $bubble.trigger("click");
          clearInterval(t);
          return;
        }
      }

      const bubbleEl = document.querySelector(".okeSurveys .c-floatingBubble");
      if (bubbleEl) {
        bubbleEl.click();
        clearInterval(t);
        return;
      }

      if (tries > 20) clearInterval(t);
    }, 100);
  }

  function triggerSurvey(target) {
    if (
      window.okeConnectApi &&
      typeof window.okeConnectApi.raiseCustomEvent === "function" &&
      target.eventName
    ) {
      // forceShow=true so a user click always opens it
      window.okeConnectApi.raiseCustomEvent(target.eventName, true);
      return;
    }
    openOkendoSurveyBubbleWithRetry();
  }

  function openKlaviyoForm(formId) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", formId]);
  }

  function makeReplacementButton(target) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "c-button c-button--customisable c-button--stretch";
    btn.textContent = target.buttonText;

    btn.addEventListener("click", (e) => {
      e.preventDefault();

      if (target.action === "klaviyo_popup") {
        openKlaviyoForm(target.klaviyoFormId);
        return;
      }

      triggerSurvey(target);
    });

    return btn;
  }

  function findTarget(titleText) {
    if (!titleText) return null;
    const t = titleText.trim();
    return TARGETS.find((x) => x.titles.includes(t)) || null;
  }

  function signatureFor(target) {
    return [
      target.action || "",
      target.eventName || "",
      target.klaviyoFormId || "",
      target.buttonText || "",
    ].join("|");
  }

  function run() {
    const cards = document.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return false;

    let changed = false;

    cards.forEach((card) => {
      const titleText = card.querySelector(TITLE_SELECTOR)?.textContent;
      const target = findTarget(titleText);
      if (!target) return;

      const signature = signatureFor(target);
      if (card.getAttribute(PROCESSED_ATTR) === signature) return;

      const oldBtn = card.querySelector(EXISTING_BTN_SELECTOR);
      if (!oldBtn) return;

      card.setAttribute(PROCESSED_ATTR, signature);
      oldBtn.replaceWith(makeReplacementButton(target));
      changed = true;
    });

    return changed;
  }

  // Bounded poll instead of MutationObserver (prevents infinite render / CPU peg)
  function startPolling() {
    let tries = 0;
    const maxTries = 40;     // ~12s
    const intervalMs = 300;

    const timer = setInterval(() => {
      tries++;

      // run() returns true if it made changes
      run();

      // stop once we've seen cards and processed them a few times,
      // or after maxTries no matter what
      const cardsExist = document.querySelectorAll(CARD_SELECTOR).length > 0;
      const processedAny = document.querySelector(`[${PROCESSED_ATTR}]`);

      if ((cardsExist && processedAny) || tries >= maxTries) {
        clearInterval(timer);
      }
    }, intervalMs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startPolling);
  } else {
    startPolling();
  }
})();



  // 6) Swatch horizontal scroll button
  (function () {
    const BTN_CLASS = "itg-swatch-scroll-btn";
    const WRAP_CLASS = "itg-swatch-scroll-wrap";
    const SCROLL_RATIO = 0.5;

    const mql = window.matchMedia("(max-width: 768px)");
    function isMobile() {
      return mql.matches;
    }

    function ensureWrapper(swatches) {
      const parent = swatches.parentElement;
      if (!parent) return null;

      if (parent.classList.contains(WRAP_CLASS)) return parent;

      const wrap = document.createElement("div");
      wrap.className = WRAP_CLASS;

      parent.insertBefore(wrap, swatches);
      wrap.appendChild(swatches);

      return wrap;
    }

    function removeButton(wrap) {
      if (!wrap) return;
      const btn = wrap.querySelector("." + BTN_CLASS);
      if (btn) btn.remove();
    }

    function shouldShowButton(swatches) {
      return swatches.scrollWidth > swatches.clientWidth + 4;
    }

    function atEnd(swatches) {
      return swatches.scrollLeft + swatches.clientWidth >= swatches.scrollWidth - 4;
    }

    function updateBtn(swatches, btn) {
      if (!shouldShowButton(swatches) || atEnd(swatches)) {
        btn.classList.add("is-hidden");
      } else {
        btn.classList.remove("is-hidden");
      }
    }

    function addButton(swatches) {
      if (!isMobile()) return;

      const wrap = ensureWrapper(swatches);
      if (!wrap) return;

      if (!shouldShowButton(swatches)) {
        removeButton(wrap);
        return;
      }

      let btn = wrap.querySelector("." + BTN_CLASS);
      if (!btn) {
        btn = document.createElement("button");
        btn.type = "button";
        btn.className = BTN_CLASS;
        btn.setAttribute("aria-label", "Scroll colors");

        btn.innerHTML = `
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        `;

        btn.addEventListener("click", () => {
          swatches.scrollBy({
            left: swatches.clientWidth * SCROLL_RATIO,
            behavior: "smooth",
          });
        });

        wrap.appendChild(btn);

        swatches.addEventListener("scroll", () => updateBtn(swatches, btn), { passive: true });
        window.addEventListener("resize", () => updateBtn(swatches, btn), { passive: true });
      }

      updateBtn(swatches, btn);
    }


  })();

  // -----------------------------
  // Loader hide strategy
  // -----------------------------
  // Your script does multiple delayed passes (400ms, 1200ms) and then observers keep running.
  // We hide once the “initial layout” is likely settled.
  function hideLoaderAfterInitialPasses() {
    // Wait for DOMContentLoaded + your delayed Okendo hydration passes
    // then hide after two paint frames for smoothness.
    const HIDE_AFTER_MS = 1600;

    setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          hideLoader();
        });
      });
    }, HIDE_AFTER_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      // show again just in case the early show ran before body existed
      showLoader();
      hideLoaderAfterInitialPasses();
    });
  } else {
    hideLoaderAfterInitialPasses();
  }
})();
